/**
 * @import { Filters } from '@/features/world-map/types/filters'
 */

import { useState } from 'react';
import { FiltersContext } from '../context/filters';

const validCruiseTypes = ['rivers', 'oceans', 'expeditions'];

/**
 * Parse voyage type from URL parameters
 * @returns {string[]}
 */
const getInitialCruisesFromUrl = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const voyageType = searchParams.get('voyageType');
  
  if (voyageType && validCruiseTypes.includes(voyageType)) {
    return [voyageType];
  }
  
  return [];
};

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.JSX.Element}
 */

export const FiltersProvider = ({ children }) => {
  const [filters, setFilters] = useState(
    /** @type {Filters} */ ({
      years: [],
      months: [],
      durations: [],
      cruises: getInitialCruisesFromUrl(),
    })
  );

  return <FiltersContext.Provider value={{ filters, setFilters }}>{children}</FiltersContext.Provider>;
};
